import { NOTIFICATIONS_STATUS_MAP } from '../utils/constants';

export const fireFormSubmittedEventWithOrderStatus = (
  values,
  formStatus,
  fireEvent
) => {
  const checkedOrderStatus = (status: string) => {
    const isOrderStatusChecked = values?.filterByOrderStatuses.find(
      (item) => item.orderStatus === status
    );
    return isOrderStatusChecked ? 'Y' : 'N';
  };

  fireEvent({
    formLocation: 'Filter by order status – Notification Preferences',
    formName: 'Notification Preferences Drawer - By Order Status',
    formContent: `Order Processing: OPCS-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.OR
    )}, CAN-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.OC
    )}, OPRB-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.EX
    )}, OH-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.OH
    )}, QONP-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.QX
    )}, QFP-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.H
    )} | Pickup: RFP-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.RP
    )}, PRFP-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.PA
    )}, PU-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.PU
    )} | Delivery: PS-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.PS
    )}, FS-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.FS
    )}, FD-${checkedOrderStatus(NOTIFICATIONS_STATUS_MAP.DL)}`,
    formContent2: `Quote Reminder: ETQ-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.NEW
    )}, EQ-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.EXP
    )} | Order Approval : EA-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.E
    )}, SFA-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.W
    )}, OP-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.OP
    )}, OA-${checkedOrderStatus(
      NOTIFICATIONS_STATUS_MAP.APR
    )}, OR-${checkedOrderStatus(NOTIFICATIONS_STATUS_MAP.N)}`,
    formStatus: formStatus,
    formFieldCausingError:
      formStatus === 'fail' ? 'Invalid field(s) causing error' : ''
  });
};
